module.exports = __webpack_public_path__ + "media/lacCalme.41ac6b2e.webm";